import pochki from '../../assets/service-icons/pochki.png';
import checkup from '../../assets/service-icons/check-up.png';
import dialis from '../../assets/service-icons/dialis.png';
import team from '../../assets/service-icons/team.png';

import './services.styles.scss';

const Services = () => {
  return (
    <section id='services'>
      <div className='max-width'>
        <h1>Чим я можу допомогти</h1>
        <div className='content'>
          <div className='card'>
            <div className='box'>
              <img src={`${pochki}`} alt='' width='66px' height='54px' />
              <h3>Діагностика та лікування запальних захворювань</h3>
              <p>
                Часто звичайні неспецифічні симптоми запалення як-то
                температура, загальна слабкість та інші можуть бути причиною
                запалення нирок - пієлонефриту.
                <br /> <br />
                Але достовірне встановлення діагнозу потребує додаткових
                неспецифічних симптомів та дообстеження. <br /> <br />
                Саме це є предметом нашої консультації.
              </p>
            </div>
          </div>
          <div className='card'>
            <div className='box'>
              <img src={`${checkup}`} alt='' width='53px' height='52px' />
              <h3>Нефрологічний сheck-up, динамічне спостереження</h3>
              <p>
                Підступність хвороб нирок, особливо особливо хронічних є
                «таємний» перебіг.
                <br />
                <br />
                Часто нирки не болять, а поступово втрачають свою функцію.
                <br /> <br />
                Тому людям, чиї родичі мають проблеми з нирками слід регулярно
                обстежуватись - це і є нефрологічний Check-up. <br /> <br />
                Задачею лікаря в цьому випадку є правильна інтерпритація
                обстежень та уважне динамічне спостереження.
              </p>
            </div>
          </div>
          <div className='card'>
            <div className='box'>
              <img src={`${dialis}`} alt='' width='49px' height='54px' />
              <h3>Вирішення питання щодо початку замісної терапії</h3>
              <p>
                На жаль не завжди нирки можна цілком вилікувати. Тоді постає
                питання щодо початку замісної терапії.
                <br /> <br />
                Існує кілька видів замісної ниркової терапії - перитоніальний
                діаліз, гемодіаліз та пересадка нирки.
                <br /> <br />
                Вчасно розпочати таку терапію - є можливістю продовжувати жити
                даліе.
              </p>
            </div>
          </div>
          <div className='card'>
            <div className='box'>
              <img src={`${team}`} alt='' width='62px' height='55px' />
              <h3>Додаткові консультації інших лікарів</h3>
              <p>
                Хвороби нирок не є ізольованими і часто пошкоджують інші органи
                та системи - серце, судини, ендокринні залози, шлунок,
                опорно-м’язову систему.
                <br />
                <br />
                Це не повний список, також хочу зазаначити що в кожного пацієнта
                перебіг хвороби дуже індивідуальний.
                <br /> <br />
                Тому у разі необхідності вважаю необхідним рекомендувати
                консультації інших лікарів.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
